import classNames from "classnames";
import React from "react";
import { MdAdd, MdCheck, MdInfoOutline, MdRemove } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Button from "../Components/Button";
import Cost from "../Components/Cost";
import Stars from "../Components/Stars";

function UpsellsCard({
  name,
  alias,
  cost,
  currency,
  onAdd,
  notSelected,
  onDetailsClick,
  supportingInformation,
}) {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const stars = parseInt(String(alias).replace(/\D/g, "")) || 1;
  return (
    <>
      {isMobile ? (
        <div className="mobilityMutual-upsells__item --mobile">
          <div className="mobilityMutual-upsells-card">
            <div
              className={classNames("mobilityMutual-upsells-card__container", {
                "mobilityMutual-upsells-card__not-selected": notSelected,
              })}
            >
              <Button type="primary" onClick={onAdd}>
                {notSelected ? <MdAdd size={14} /> : <MdRemove size={14} />}
              </Button>
              <span className="--name">{name}</span>
              <Cost cost={cost} currency={currency} className="--cost" />
              <div onClick={onDetailsClick} className="--link-mobile">
                <MdInfoOutline size={24} color="#80bc00" />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={classNames("upsells-wrapper__item", {
            "upsells-wrapper__item--selected": !notSelected,
          })}
          onClick={onAdd}
        >
          <div
            className={classNames("upsells-wrapper-card__container", {
              "upsells-wrapper-card__not-selected": notSelected,
            })}
          >
            <div className="upsells-wrapper-card__header">
              <div className="upsells-wrapper-card__header-left">
                <div
                  className={classNames("upsells-wrapper-card__checkbox", {
                    "upsells-wrapper-card__checkbox--selected": !notSelected,
                  })}
                >
                  {!notSelected && (
                    <MdCheck
                      size={16}
                      className="upsells-wrapper-card__checkbox-checkmark"
                    />
                  )}
                </div>
                <div className="upsells-wrapper-card__title-section">
                  <div
                    className={classNames("upsells-wrapper-card__title", {
                      "upsells-wrapper-card__title--selected": !notSelected,
                    })}
                  >
                    {name}

                    <Stars count={stars} />
                  </div>
                  <div
                    className={classNames("upsells-wrapper-card__tagline", {
                      "upsells-wrapper-card__tagline--selected": !notSelected,
                    })}
                  >
                    Une sur-complémentaire solide pour renforcer vos
                    remboursements
                  </div>
                </div>
              </div>
              <div className="upsells-wrapper-card__header-right">
                <div
                  className={classNames("upsells-wrapper-card__price", {
                    "upsells-wrapper-card__price--selected": !notSelected,
                  })}
                >
                  <span
                    className={classNames("upsells-wrapper-card__price-value", {
                      "upsells-wrapper-card__price-value--selected":
                        !notSelected,
                    })}
                  >
                    {costToFrench(cost)} {CURRENCY_SYMBOL[currency] || ""}
                  </span>
                  <span
                    className={classNames(
                      "upsells-wrapper-card__price-period",
                      {
                        "upsells-wrapper-card__price-period--selected":
                          !notSelected,
                      },
                    )}
                  >
                    /mois
                  </span>
                </div>
              </div>
            </div>
            {supportingInformation && supportingInformation.length > 0 && (
              <div className="upsells-wrapper-card__benefits">
                {supportingInformation
                  .flatMap((item) => item.value || [])
                  .map((benefit, index, array) => (
                    <React.Fragment key={index}>
                      <div className="upsells-wrapper-card__benefit-item">
                        <span className="upsells-wrapper-card__benefit-label">
                          {benefit.mainInfo}
                        </span>
                        <span className="upsells-wrapper-card__benefit-value">
                          {benefit.description}
                        </span>
                      </div>
                      {index < array.length - 1 && (
                        <div className="upsells-wrapper-card__benefit-divider" />
                      )}
                    </React.Fragment>
                  ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(UpsellsCard);
